export default __webpack_public_path__ + "static/media/note.5d6d8131.svg";